import { render } from "./CreateInstrument.vue?vue&type=template&id=3543dcbc&scoped=true"
import script from "./CreateInstrument.vue?vue&type=script&lang=js"
export * from "./CreateInstrument.vue?vue&type=script&lang=js"

import "./CreateInstrument.vue?vue&type=style&index=0&id=3543dcbc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3543dcbc"]])

export default __exports__